<div>
	<p [tabindex]="0" class="fs-5 w-100 d-flex justify-content-between align-items-center">
		<span>
			Przystanek:
			<span class="fw-bold"> {{ dialogData().currentCity.location.name }}</span>
		</span>
		@if (dialogData().vehicleInUse) {
			<span>
				Ilość zabranych:
				<span class="fw-bold"
					>{{ takenParticipantsAmount() }} /
					{{ dialogData().vehicleInUse.capacity - dialogData().vehicleInUse.crew }}</span
				>
			</span>
		}
	</p>
	@if (!dialogData().vehicleInUse) {
		<div class="alert alert-danger">Pamiętaj o wybraniu pojazdu!</div>
	}

	<div class="d-flex flex-row gap-5">
		<div class="col">
			Programy do zabrania
			<app-participants-tab
				[action]="ParticipantsTabAction.TAKE"
				[programs]="programs()"
				[buttonDisabled]="!dialogData().vehicleInUse"
				[city]="dialogData().currentCity"
				[vehicle]="dialogData().vehicleInUse"
				(updatePrograms)="updatePrograms($event)"
			></app-participants-tab>
		</div>
		<div class="col">
			Zabrane programy
			<app-participants-tab
				[action]="ParticipantsTabAction.LEAVE"
				[programs]="programs()"
				[buttonDisabled]="!dialogData().vehicleInUse"
				[city]="dialogData().currentCity"
				[vehicle]="dialogData().vehicleInUse"
				(updatePrograms)="updatePrograms($event)"
			></app-participants-tab>
		</div>
	</div>

	<mat-dialog-actions align="end">
		<button mat-button color="primary" [disabled]="!dialogData().vehicleInUse" (click)="save()">Zapisz</button>
		<button mat-button color="warn" (click)="close()">Zamknij</button>
	</mat-dialog-actions>
</div>
